import Person, { Phone } from "@/types/Person.interface"

const defaults = () => {}

export default {
    state: defaults(),
    mutations: {},
    actions: {
        phoneNumbersDuplicates ({ getters }, phoneNumber: number): Promise<Person[]> {
            //  Assemble the API endpoint
            const url = `${getters.api}/phone-numbers/duplicates?phone=${phoneNumber}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return an array of channel ids matching the duplicates
                return response.data
            }).catch(() => null)
        },
        phoneNumbersPut ({ getters }, phone: Phone): Promise<Phone> {
            //  ASsemble the API endpoint
            const url = `${getters.api}/phone-numbers`

            //  Send the request
            return window.axios.put(url, phone).then(response => {
                //  REturn our updated phone number
                return response.data
            }).catch(() => null)
        },
        phoneNumbersPutBatch ({ getters }, phones: Phone[]): Promise<Phone[]> {
            //  Assemble the API endpoint
            const url = `${getters.api}/phone-numbers/batch`

            //  Send the request
            return window.axios.put(url, phones).then(response => {
                //  Return our updated phone numbers
                return response.data
            }).catch(() => null)
        },
        phoneNumbersBlock ({ getters }, phones: Phone[]): Promise<Phone[]> {
            //  Assemble the API endpoint
            const url = `${getters.api}/phone-numbers/block`

            //  Send the request
            return window.axios.post(url, phones).then(response => {
                //  REturn our blocked numbers
                return response.data
            }).catch(() => null)
        },
        phoneNumbersUnblock ({ getters }, phones: Phone[]): Promise<Phone[]> {
            //  ASsemble the aPI endpoint
            const url = `${getters.api}/phone-numbers/unblock`

            //  Send the request
            return window.axios.post(url, phones).then(response => {
                //  Return the unblocked phone numbers
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        dataProviderPhones(): object[] {
            return [
                {
                    name: 'Home Phone',
                    field: 'phone_home.free_form_number',
                },
                {
                    name: 'Work Phone',
                    field: 'phone_work.free_form_number',
                },
                {
                    name: 'Fax Phone',
                    field: 'phone_home_fax.free_form_number',
                }
            ]
        }
    }
}